export default __webpack_public_path__ + "static/media/preview-icon.1707ec61.svg";